import * as L from 'leaflet';

export async function loadLeaflet() {
  window.L ??= L;
  await Promise.all([
    import('leaflet.motion/dist/leaflet.motion.min.js'),
    import('leaflet.gridlayer.googlemutant'),
    import('leaflet-canvas-marker'),
    import('leaflet-polylinedecorator'),
    import('leaflet.markercluster'),
    import('leaflet-draw'),
  ]);
}

const Leaflet = window.L;
export { Leaflet as L };
